<app-resource-subtitle></app-resource-subtitle>
<div class="row">
    <div
        class="asset-container"
        [ngClass]="{
            'col-lg-12': resourceService.focusView,
            'col-lg-8': !resourceService.focusView,
        }"
    >
        <div class="video-containers">
            <app-video
                [isCautionFlagContainerDisplayed]="isCautionFlagContainerDisplayed"
                class="app-video-container"
                *ngIf="resource"
                [gtmVideoJsInfo]="gtmVideoJsInfo"
                [muxData]="muxData"
                [videoMedia]="resource.getSelectedMedia()"
            >
            </app-video>
        </div>
        <app-resource-details></app-resource-details>
    </div>
    <div *ngIf="!resourceService.focusView" class="col-lg-4 recommended selenium-related-resources">
        <app-support-material-panel
            *ngIf="!windowSize.isTablet"
            [resource]="resource"
            style="margin-bottom: 30px"
        ></app-support-material-panel>
        <ng-container *ngIf="!isAddonView">
            <app-related-resources
                *ngIf="resource"
                [resource]="resource"
                class="selenium-you-may-also-like"
            ></app-related-resources>
            <app-curriculum-tags></app-curriculum-tags>
        </ng-container>
    </div>
</div>
<div *ngIf="!resourceService.focusView && !isAddonView" class="row-auto">
    <app-more-from-collection></app-more-from-collection>
</div>
